<template>
    <b-container>
        <component :is="to ? 'router-link' : 'div'"
                   class="m-2 d-block"
                   :to="to ? to : {}">
            <b-row @click="clickEvent ? clickEvent(articleDetails) : null"
                   v-bind:class="[{ asLink: to || clickEvent}]"
                   class="article-item py-2 text-left">
                <b-col cols="2" class="image">
                    <img v-if="thumbnail" :src="imageResource(thumbnail, 200)"/>
                </b-col>
                <b-col>
                    <div class="description">
                        {{articleDetails.primaryDescription || articleDetails.secondaryDescription}}
                    </div>
                    <div class="name py-1">
                        {{articleDetails.name}}
                    </div>
                </b-col>
                <b-col v-if="price" cols="4" class="text-right price text-nowrap">
                    {{price.value | currency($currencyFormatting[price.currency])}}
                </b-col>
            </b-row>
        </component>
    </b-container>
</template>
<script>

    export default {
        name: "article-preview",
        props: {
            articleDetails: {
                type: Object

            },
            to: {
                type: Object
            },
            price: {
                type: Object
            },
            thumbnail: {
                type: String
            }
        },
        computed: {
            clickEvent: function () {
                return this._events && this._events['click'] ? this._events['click'][0] : null;
            }
        }
    }

</script>

<style lang="scss" scoped>
    @import "~@shared/_assets/scss/constants";

    .article-item {
        font-size: 13px;
        font-family: $font-muli;
        background-color: #F1F1F1;
        min-height: 70px;
        font-weight: 300;

        .name {
            font-size: 11px;
            color: #4A4B4D;
        }

        .description {
            font-family: $font-robo;
            color: #111111;
        }

        img {
            max-height: 55px;
            width: 100%;
            height: 100%;
            margin: auto;
            -o-object-fit: contain;
            object-fit: contain;
        }

        &.asLink:hover {
            cursor: pointer;
            box-shadow: 2px 1px 9px 0 rgba(0, 0, 0, 0.3);
        }
    }
</style>